import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { useForm, Link } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'

export default function ActivitiesEdit({ activity }) {
  const { data, setData, patch, processing, errors } = useForm({
    name: activity.name,
    description: activity.description || '',
  })

  function handleSubmit(e) {
    e.preventDefault()
    patch(`/activities/${activity.id}`)
  }

  return (
    <AuthenticatedLayout>
      <div className="max-w-lg">
        <div className="mb-6">
          <Link href={`/activities/${activity.id}`} className="text-sm text-indigo-600 hover:underline">
            ← {activity.name}
          </Link>
          <h1 className="text-2xl font-bold text-gray-900 mt-2">Redigera aktivitet</h1>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="Namn" error={errors.name}>
              <input
                type="text"
                value={data.name}
                onChange={e => setData('name', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>

            <FormField label="Beskrivning" error={errors.description}>
              <textarea
                value={data.description}
                onChange={e => setData('description', e.target.value)}
                rows={4}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>

            <div className="flex gap-3">
              <Button type="submit" disabled={processing}>
                {processing ? 'Sparar…' : 'Spara ändringar'}
              </Button>
              <Link href={`/activities/${activity.id}`}>
                <Button type="button" variant="secondary">Avbryt</Button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
